import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ClassifierControlsColumn, ClassifierControlsDataSource } from '../types'

const getColumnsOptions = (): Array<Column<ClassifierControlsColumn>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof ClassifierControlsColumn>

  return columnKeys.map(key => {
    const column: Column<ClassifierControlsColumn> = {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<ClassifierControlsDataSource>> =>
  [
    ...getColumnsFromMap<ClassifierControlsColumn>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<ClassifierControlsDataSource>>
